export default {
    api_securit: 'yTnbPqdX5LP35MUHsdH40B5yYWt9JG1fb',
    trace_securit: 'zUSsUTJRU3czNnpwyc55m4Gv7CRYcAsO',
    version: '2.7.3' //接口版本号
};
